import { FirebaseReturnClientRepository } from "@data/repositories/index";
import { WatchReturnsUseCase } from "@useCases/index";
import returnClientStore from "@data/stores/returnClient";
import userStore from "@data/stores/user";
import { useEffect } from "react";
import { useStore } from "zustand";

export default function useReturns() {
  const { returns } = useStore(returnClientStore);

  const getReturns = () => {
    const useCase = new WatchReturnsUseCase(
      userStore.getState(),
      new FirebaseReturnClientRepository(returnClientStore.getState())
    );

    useCase.execute();
  };

  useEffect(() => {
    if (returns.completed.length === 0) {
      getReturns();
    }
  }, []);

  return {
    returns,
  };
}
